"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var api_1 = require("./api");
var action_types_1 = require("./action-types");
var reducers_1 = require("./reducers");
var selectors_1 = require("./selectors");
exports.setUserLocale = function (userLocale) { return ({ type: action_types_1.SET_USER_LOCALE, userLocale: userLocale }); };
exports.setLocaleList = function (localeList) { return ({ type: action_types_1.SET_LOCALE_LIST, localeList: localeList }); };
exports.setLocaleBundle = function (code, bundle, name) {
    if (name === void 0) { name = undefined; }
    return ({ type: action_types_1.SET_LOCALE_BUNDLE, code: code, bundle: bundle, name: name });
};
exports.setUserLocaleAndBundle = function (code, bundle, name) { return function (dispatch) {
    code = code || bundle.locale;
    name = name || bundle.name;
    dispatch(exports.setUserLocale(code));
    if (!bundle) {
        throw new Error("No bundle received for " + code + "_" + name + ".");
    }
    dispatch(exports.setLocaleBundle(code, bundle, name));
}; };
exports.getLocaleBundle = function (code, name) {
    if (name === void 0) { name = reducers_1.DEFAULT_CLIENT_BUNDLE_NAME; }
    return function (dispatch, getState) {
        if (selectors_1.hasBundleById(getState(), code, name)) {
            return dispatch(exports.setUserLocale(code));
        }
        return api_1.fetchLocaleBundle(code, name).then(function (response) { return dispatch(exports.setUserLocaleAndBundle(code, response.bundle, name)); });
    };
};
exports.getNativeLocaleBundle = function (code, name) {
    if (name === void 0) { name = reducers_1.DEFAULT_NATIVE_BUNDLE_NAME; }
    return function (dispatch, getState) {
        if (selectors_1.hasBundleById(getState(), code, name)) {
            return dispatch(exports.setUserLocale(code));
        }
        return api_1.fetchNativeLocaleBundle(code, name).then(function (response) { return dispatch(exports.setUserLocaleAndBundle(code, response.bundle, name)); });
    };
};
exports.changeLocale = function (code, name) {
    if (name === void 0) { name = reducers_1.DEFAULT_CLIENT_BUNDLE_NAME; }
    return function (dispatch, getState) {
        if (selectors_1.hasBundleById(getState(), code, name)) {
            return api_1.postUserLocale(code).then(function () { return dispatch(exports.setUserLocale(code)); });
        }
        return Promise.all([api_1.postUserLocale(code), api_1.fetchLocaleBundle(code, name)])
            .then(function (_a) {
            var _b = tslib_1.__read(_a, 2), userResponse = _b[0], bundleResponse = _b[1];
            return dispatch(exports.setUserLocaleAndBundle(userResponse.locale, bundleResponse.bundle, name));
        });
    };
};
//# sourceMappingURL=actions.js.map